<template>
  <div>
    <event-form
      :event="event"
      :submit="submit"
    />
  </div>
</template>

<script>
import EventForm from '@/components/Events/EventForm.vue'
import Events from '@/compositions/Events/EventsAPI'
import handleAlerts from '@/compositions/common/handleAlerts'

export default {
  name: 'EditEvent',
  components: { EventForm },
  setup() {
    const { event, getEventRequest, updateEventRequest } = Events()
    const { successfulOperationAlert } = handleAlerts()
    return {
      event, getEventRequest, updateEventRequest, successfulOperationAlert,
    }
  },
  created() {
    this.getEvent()
  },
  methods: {
    getEvent() {
      this.getEventRequest(this.$route.params.id).then(res => {
        this.event = { ...res.data.data, main_image: res.data.data.main_image || {} }
      })
    },
    submit() {
      return this.updateEventRequest(this.$route.params.id).then(() => {
        this.successfulOperationAlert('Event is updated successfully')
        this.$router.push({ name: 'organization-profile', query: { firstTabIndex: 1 } })
      })
    },
  },
}
</script>

<style>

</style>
